// A flex item refuses to shrink below its content's automatic minimum size, so without this
// a long page pushes the column past the bounded shell instead of scrolling inside it.
.section {
  min-height: 0;
}
